import YoutubeIframe from "../generic/YoutubeIframe";

interface Props {}

function MusicCoversPage(props: Props) {
  return (
    <>
      <YoutubeIframe src="https://www.youtube.com/embed/videoseries?si=babAyj8UB6CErIEz&amp;list=PLjJviynXD1X22t4M4m-0xWxcrIfZppYMj" />
      <div className="centered-list-of-stuff">
        <p>The above playlist of live-ish covers was recorded in 2026.</p>
        <div>
          If you're looking for a specific song, see the full listing{" "}
          <a href="https://youtube.com/@curtisvoorhees?si=LrKJ4TO3W3aNiPyV" target="_blank" rel="noreferrer">
            here
          </a>
          .  Open to requests!
        </div>
      </div>
    </>
  );
}

export default MusicCoversPage;
